export const global_breakpoint_sm = {
  "name": "--pf-v5-global--breakpoint--sm",
  "value": "576px",
  "var": "var(--pf-v5-global--breakpoint--sm)"
};
export default global_breakpoint_sm;